
<p-chip
    styleClass="p-mr-2"
    [label]="zone.name"
>
</p-chip>